
export const burjanfanni = {
  personal_video: {
    title: "Order a Personal Video Message",
    description: "Order a personalized, fun video message for yourself or your loved ones",
    button: "Order Now",
    price: {
      standard: "3,990 Ft",
      premium: "5,990 Ft",
      exclusive: "9,990 Ft"
    }
  },
  video_message: {
    orderForm: {
      occasionSection: "What's the occasion?",
      occasion: {
        birthday: "Birthday",
        nameday: "Name Day",
        motivation: "Motivation",
        congratulation: "Congratulations",
        other: "Other"
      },
      title: "Personalized Video Message",
      subtitle: "Request a personal video message from me",
      recipientInfo: "Who is the video for?",
      forMyselfLabel: "I want the video for myself",
      recipientNameLabel: "Who is the video for?",
      recipientNamePlaceholder: "E.g. Sarah",
      senderNameLabel: "Who is requesting the video?",
      senderNamePlaceholder: "E.g. John",
      instructionsLabel: "Additional information, requests",
      instructionsPlaceholder: "Describe what you'd like me to say in the video...",
      submit: "Place Order"
    }
  },
  bundle: {
    title: "Exclusive Packages",
    description: "Browse our personalized packages",
    details: {
      includesTitle: "Package includes:",
      buyButton: "Buy Now",
      backButton: "Back to packages",
      process: {
        title: "How does it work?",
        steps: [
          { title: "Choose a package", description: "Browse exclusive packages and pick the one that suits you best." },
          { title: "Complete payment", description: "Complete your purchase through our secure payment system." },
          { title: "Access the content", description: "After successful payment, you'll have immediate access to all content." },
          { title: "Schedule personal elements", description: "We'll coordinate the details of the video message or personal meeting." }
        ]
      },
      faq: {
        title: "FAQ",
        questions: [
          { question: "How long can I access the content?", answer: "You have unlimited access to purchased digital content through your account." },
          { question: "How will I receive the video message?", answer: "The personal video message will be uploaded to your account, and you'll be notified by email." },
          { question: "How long is the package valid?", answer: "Packages are valid for 3 months from purchase; personal elements must be used within this time." },
          { question: "Can I cancel the meeting?", answer: "Cancellation or rescheduling is possible up to 48 hours before the booked time." }
        ]
      },
      reviews: {
        title: "Customer Reviews",
        average: "Average rating",
        reviews: [
          { name: "Anna K.", rating: 5, date: "Dec 15, 2023", comment: "Fantastic experience! Every element of the package was perfect." },
          { name: "Peter N.", rating: 5, date: "Nov 3, 2023", comment: "The best gift I've ever given! Everyone loved the video message." },
          { name: "Ben T.", rating: 4, date: "Oct 22, 2023", comment: "Very satisfied with the package, highly recommend it to everyone!" }
        ]
      }
    }
  }
};
